<template>
  <v-alert
    v-model="alert"
    :type="type"
    border="left"
    close-text="Fermer l'alerte"
    dismissible
    outlined
    text
    transition="scale-transition"
    origin="left center"
    elevation="5"
  >
    <!-- Bar de progression -->
    <v-progress-linear
      :color="type"
      :value="timeoutProgress"
      striped
      absolute
      top
    />
    <strong>{{ msg }}</strong>
  </v-alert>
</template>

<script>
  /* Rend le composant accessible aux autres composants */
  export default {
    /* Nom du composant */
    name: 'HappyQuest',

    /* Paramètres */
    props: {
      display: {
        type: Boolean,
        default: false,
      },
      type: {
        type: String,
        default: 'error',
      },
      msg: {
        type: String,
        default: 'Une erreur est survenue. Si celle-ci persiste, merci de contacter un administrateur.',
      },
      countDown: {
        type: Object,
        default: function () {
          return {
            timerInit: 5000,
            steps: 100,
            timer: 0,
          }
        },
      },
    },

    /* Variables internes
     * data doit être une fonction si ce composant est utilisé dans un autre composant */
    data: function () {
      return {
        alert: false,
      }
    },

    /* Variables internes dynamiques
     * (MAJ automatique quand les variables qu'elles utilisent sont mises à jour) */
    computed: {
      timeoutProgress: function () {
        return ((this.countDown.timerInit - this.countDown.timer) / this.countDown.timerInit) * 100
      },
    },

    /* Variables surveillées : traitement si modification de sa valeur */
    watch: {
      display: function (newVal) {
        this.alert = newVal
        window.clearTimeout()
        this.beginTimer()
      },
    },

    /* Fonctions internes */
    methods: {
      beginTimer: function () {
        this.initTimer()
        this.countDownTimer()
      },

      countDownTimer () {
        if (this.countDown.timer > 0 && this.alert) {
          window.setTimeout(() => {
            this.countDown.timer -= this.countDown.steps
            this.countDownTimer()
          }, this.countDown.steps)
        } else {
          window.clearTimeout()
          this.resetTimer()
          this.alert = false
        }
      },

      initTimer () {
        this.countDown.timer = this.countDown.timerInit
      },

      resetTimer () {
        this.countDown.timer = 0
      },
    },
  }
</script>
